(function () {
  if (window.__featuredCollectionRedesign) {
    return;
  }
  window.__featuredCollectionRedesign = true;

  var cleanups = new WeakMap();

  function initSection(root) {
    var desktopMql = window.matchMedia(root.dataset.desktopMedia || '(min-width: 66.001em)');
    var reduceMql = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ac = new AbortController();
    var signal = ac.signal;

    function isDesktop() {
      return desktopMql.matches;
    }

    function allowMotion() {
      return !reduceMql.matches;
    }

    var viewportFns = [];

    function bindCard(card) {
      var videoDesktop = card.querySelector('[data-fcr-hover-video="desktop"] video');
      var videoMobile = card.querySelector('[data-fcr-hover-video="mobile"] video');
      var scroller = card.querySelector('[data-media-scroller]');
      var dots = card.querySelectorAll('[data-fcr-media-dot]');
      var hasSecondary = card.getAttribute('data-has-secondary') === 'true';

      function pauseReset(v) {
        if (!v) {
          return;
        }
        v.pause();
        try {
          v.currentTime = 0;
        } catch (e) {}
      }

      function syncMobileVideo() {
        if (!allowMotion()) {
          pauseReset(videoMobile);
          return;
        }
        if (isDesktop() || !videoMobile || !hasSecondary) {
          return;
        }
        if (!scroller) {
          return;
        }
        var w = scroller.clientWidth || 1;
        var index = Math.round(scroller.scrollLeft / w);
        if (index >= 1) {
          videoMobile.play().catch(function () {});
        } else {
          pauseReset(videoMobile);
        }
      }

      function bindDesktopVideo() {
        if (!videoDesktop || !hasSecondary) {
          return;
        }
        var onEnter = function () {
          if (!isDesktop() || !allowMotion()) {
            return;
          }
          videoDesktop.play().catch(function () {});
        };
        var onLeave = function () {
          if (!isDesktop()) {
            return;
          }
          pauseReset(videoDesktop);
        };
        card.addEventListener('mouseenter', onEnter, { signal: signal });
        card.addEventListener('mouseleave', onLeave, { signal: signal });
      }

      function bindScroller() {
        if (!scroller || !hasSecondary) {
          return;
        }
        var onScroll = function () {
          var w = scroller.clientWidth || 1;
          var index = Math.round(scroller.scrollLeft / w);
          dots.forEach(function (dot, i) {
            var active = i === index;
            dot.setAttribute('aria-current', active ? 'true' : 'false');
            dot.classList.toggle('is-active', active);
          });
          syncMobileVideo();
        };
        scroller.addEventListener('scroll', onScroll, { passive: true, signal: signal });
        if ('onscrollend' in window) {
          scroller.addEventListener('scrollend', onScroll, { passive: true, signal: signal });
        }
        dots.forEach(function (dot) {
          dot.addEventListener(
            'click',
            function () {
              var idx = parseInt(dot.getAttribute('data-fcr-media-dot') || '0', 10);
              var w = scroller.clientWidth || 0;
              scroller.scrollTo({ left: idx * w, behavior: 'smooth' });
            },
            { signal: signal }
          );
        });
        scroller.scrollLeft = 0;
        onScroll();
      }

      function onViewportChange() {
        pauseReset(videoDesktop);
        pauseReset(videoMobile);
        if (scroller) {
          scroller.scrollLeft = 0;
        }
        syncMobileVideo();
      }

      bindDesktopVideo();
      bindScroller();
      viewportFns.push(onViewportChange);
    }

    root.querySelectorAll('[data-featured-collection-redesign-card]').forEach(bindCard);

    var onGlobalViewport = function () {
      viewportFns.forEach(function (fn) {
        fn();
      });
    };
    desktopMql.addEventListener('change', onGlobalViewport, { signal: signal });
    reduceMql.addEventListener('change', onGlobalViewport, { signal: signal });

    cleanups.set(root, function () {
      ac.abort();
    });
  }

  function boot() {
    document.querySelectorAll('[data-featured-collection-redesign]:not([data-fcr-booted])').forEach(function (root) {
      root.dataset.fcrBooted = 'true';
      initSection(root);
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-featured-collection-redesign]');
    if (root && !root.dataset.fcrBooted) {
      root.dataset.fcrBooted = 'true';
      initSection(root);
    }
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-featured-collection-redesign]');
    if (!root) {
      return;
    }
    var fn = cleanups.get(root);
    if (fn) {
      fn();
      cleanups.delete(root);
    }
    delete root.dataset.fcrBooted;
  });
})();
